import {
  ProviderFilters,
  SearchFilter,
  WbResponsiveTableToolbar,
} from '@agilelab/plugin-wb-platform';
import useDomainContext from './DomainProvider';

export interface DomainFilters extends ProviderFilters {}

export const DomainFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    useDomainContext();

  const filterElement = (key: string) => {
    if (key === 'search')
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    return <></>;
  };

  return (
    <WbResponsiveTableToolbar onClear={resetFilters} marginBottom>
      <WbResponsiveTableToolbar.Filters>
        {templateKind?.userFilters?.map(filter => filterElement(filter))}
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
